module.exports = __webpack_public_path__ + "static/img/foos.801b38a.png";